/**
 * Product Catalog Management
 * ## TMF API Reference: TMF620 - Product Catalog Management  ### Release : 19.0 - June 2019  Product Catalog API is one of Catalog Management API Family. Product Catalog API goal is to provide a catalog of products.   ### Operations Product Catalog API performs the following operations on the resources : - Retrieve an entity or a collection of entities depending on filter criteria - Partial update of an entity (including updating rules) - Create an entity (including default values and creation rules) - Delete an entity - Manage notification of events
 *
 * OpenAPI spec version: 4.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ProductOfferingPrice } from '../model/productOfferingPrice';
import { ProductOfferingPriceCreate } from '../model/productOfferingPriceCreate';
import { ProductOfferingPriceUpdate } from '../model/productOfferingPriceUpdate';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class ProductOfferingPriceService {

    protected basePath = 'https://serverRoot/tmf-api/productCatalogManagement/v4/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Creates a ProductOfferingPrice
     * This operation creates a ProductOfferingPrice entity.
     * @param productOfferingPrice The ProductOfferingPrice to be created
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createProductOfferingPrice(productOfferingPrice: ProductOfferingPriceCreate, observe?: 'body', reportProgress?: boolean): Observable<ProductOfferingPrice>;
    public createProductOfferingPrice(productOfferingPrice: ProductOfferingPriceCreate, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ProductOfferingPrice>>;
    public createProductOfferingPrice(productOfferingPrice: ProductOfferingPriceCreate, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ProductOfferingPrice>>;
    public createProductOfferingPrice(productOfferingPrice: ProductOfferingPriceCreate, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (productOfferingPrice === null || productOfferingPrice === undefined) {
            throw new Error('Required parameter productOfferingPrice was null or undefined when calling createProductOfferingPrice.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json;charset=utf-8'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json;charset=utf-8'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ProductOfferingPrice>(`${this.basePath}/productOfferingPrice`,
            productOfferingPrice,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Deletes a ProductOfferingPrice
     * This operation deletes a ProductOfferingPrice entity.
     * @param id Identifier of the ProductOfferingPrice
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteProductOfferingPrice(id: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public deleteProductOfferingPrice(id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public deleteProductOfferingPrice(id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public deleteProductOfferingPrice(id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling deleteProductOfferingPrice.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json;charset=utf-8'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json;charset=utf-8'
        ];

        return this.httpClient.delete<any>(`${this.basePath}/productOfferingPrice/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * List or find ProductOfferingPrice objects
     * This operation list or find ProductOfferingPrice entities
     * @param fields Comma-separated properties to be provided in response
     * @param offset Requested index for start of resources to be provided in response
     * @param limit Requested number of resources to be provided in response
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public listProductOfferingPrice(fields?: string, offset?: number, limit?: number, observe?: 'body', reportProgress?: boolean): Observable<Array<ProductOfferingPrice>>;
    public listProductOfferingPrice(fields?: string, offset?: number, limit?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ProductOfferingPrice>>>;
    public listProductOfferingPrice(fields?: string, offset?: number, limit?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ProductOfferingPrice>>>;
    public listProductOfferingPrice(fields?: string, offset?: number, limit?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (fields !== undefined && fields !== null) {
            queryParameters = queryParameters.set('fields', <any>fields);
        }
        if (offset !== undefined && offset !== null) {
            queryParameters = queryParameters.set('offset', <any>offset);
        }
        if (limit !== undefined && limit !== null) {
            queryParameters = queryParameters.set('limit', <any>limit);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json;charset=utf-8'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json;charset=utf-8'
        ];

        return this.httpClient.get<Array<ProductOfferingPrice>>(`${this.basePath}/productOfferingPrice`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Updates partially a ProductOfferingPrice
     * This operation updates partially a ProductOfferingPrice entity.
     * @param id Identifier of the ProductOfferingPrice
     * @param productOfferingPrice The ProductOfferingPrice to be updated
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public patchProductOfferingPrice(id: string, productOfferingPrice: ProductOfferingPriceUpdate, observe?: 'body', reportProgress?: boolean): Observable<ProductOfferingPrice>;
    public patchProductOfferingPrice(id: string, productOfferingPrice: ProductOfferingPriceUpdate, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ProductOfferingPrice>>;
    public patchProductOfferingPrice(id: string, productOfferingPrice: ProductOfferingPriceUpdate, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ProductOfferingPrice>>;
    public patchProductOfferingPrice(id: string, productOfferingPrice: ProductOfferingPriceUpdate, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling patchProductOfferingPrice.');
        }

        if (productOfferingPrice === null || productOfferingPrice === undefined) {
            throw new Error('Required parameter productOfferingPrice was null or undefined when calling patchProductOfferingPrice.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json;charset=utf-8'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json;charset=utf-8'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.patch<ProductOfferingPrice>(`${this.basePath}/productOfferingPrice/${encodeURIComponent(String(id))}`,
            productOfferingPrice,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Retrieves a ProductOfferingPrice by ID
     * This operation retrieves a ProductOfferingPrice entity. Attribute selection is enabled for all first level attributes.
     * @param id Identifier of the ProductOfferingPrice
     * @param fields Comma-separated properties to provide in response
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public retrieveProductOfferingPrice(id: string, fields?: string, observe?: 'body', reportProgress?: boolean): Observable<ProductOfferingPrice>;
    public retrieveProductOfferingPrice(id: string, fields?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ProductOfferingPrice>>;
    public retrieveProductOfferingPrice(id: string, fields?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ProductOfferingPrice>>;
    public retrieveProductOfferingPrice(id: string, fields?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling retrieveProductOfferingPrice.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (fields !== undefined && fields !== null) {
            queryParameters = queryParameters.set('fields', <any>fields);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json;charset=utf-8'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json;charset=utf-8'
        ];

        return this.httpClient.get<ProductOfferingPrice>(`${this.basePath}/productOfferingPrice/${encodeURIComponent(String(id))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
